module.exports = __webpack_public_path__ + "static/img/pic-bg.2d05ddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/blockIcon/pic-bg.png
// module id = 6wmm
// module chunks = 96